import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onMounted,
  watch,
  ref,
  shallowRef,
  nextTick,
  onUnmounted,
} from 'vue'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import throttle from 'lodash/throttle'

import { validators } from '@/utils/validate'
import { UserModule } from '@/store/modules/user'
import { getCaptchaSrc } from '@/api/user'
import type { LoginFormData } from '@/api/user/type'
import { useRoute, useRouter } from '@/router'


const __default__ = {
  name: 'Login'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const formLogoSrc = require('@/assets/img/login_form_logo.png')
const pageLogoSrc = require('@/assets/img/login_page_logo.png')
const captchaSrc = ref('')

const loginForm = ref<LoginFormData>({
  username: '',
  password: '',
  captcha: '',
})

const loginRules = {
  username: [{ validator: validators.username, trigger: 'blur' }],
  password: [{ validator: validators.password, trigger: 'blur' }],
  captcha: [{ validator: validators.captcha, trigger: ['blur', 'change'] }]
}

const passwordType = ref('password')
const loading = ref(false)
const redirect = ref('')
let otherQuery: Dictionary<string> = {}

const copyRightText = computed(() => {
  return `Copyright ${new Date().getFullYear()} 北京捷通华声科技股份有限公司`
})

const canSubmit = computed(() => {
  return Object.values(loginForm.value).every(v => typeof v === 'string' && (v.trim()).length > 0)
})
const route = useRoute()
watch(route, (route: Route) => {
  // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
  // See https://github.com/vuejs/vue-router/pull/2050 for details
  const query = route.query as Dictionary<string>
  if (query) {
    redirect.value = query.redirect
    otherQuery = getOtherQuery(query)
  }
}, {
  immediate: true
})

let timer = -1
const toggleCaptcha = throttle(() => {
  window.clearTimeout(timer)
  getCaptchaSrc().then(({ data, axiosRes: { headers } }) => {
    const blob = new Blob([data], {type: headers.contentType ?? ''})
    captchaSrc.value = window.URL.createObjectURL(blob)
    timer = window.setTimeout(toggleCaptcha, 5 * 60 * 1000) // 验证码有效期是 1min
  })
}, 2000, { trailing: false })

const loginFormRef = shallowRef<InstanceType<typeof ElForm>>()
const usernameRef = shallowRef<InstanceType<typeof Input>>()
const passwordRef = shallowRef<InstanceType<typeof Input>>()

onMounted(() => {
  toggleCaptcha()
  if (loginForm.value.username === '') {
    usernameRef.value?.focus()
  } else if (loginForm.value.password === '') {
    passwordRef.value?.focus()
  }
})
onUnmounted(() => {
  window.clearTimeout(timer)
})
function showPwd() {
  if (passwordType.value === 'password') {
    passwordType.value = ''
  } else {
    passwordType.value = 'password'
  }
  nextTick(() => {
    passwordRef.value?.focus()
  })
}

const router = useRouter()

function handleLogin() {
  loginFormRef.value?.validate(async(valid: boolean) => {
    if (valid) {
      loading.value = true
      try {
        await UserModule.Login(loginForm.value)
        await UserModule.GetUserInfo()
        await router.push({
          path: redirect.value || '/',
          query: otherQuery
        })
      } catch (e) {
        toggleCaptcha()
      } finally {
        loading.value = false
      }
    } else {
      return false
    }
  })
}

function getOtherQuery(query: Dictionary<string>) {
  return Object.keys(query).reduce((acc, cur) => {
    if (cur !== 'redirect') {
      acc[cur] = query[cur]
    }
    return acc
  }, {} as Dictionary<string>)
}

return { __sfc: true,formLogoSrc, pageLogoSrc, captchaSrc, loginForm, loginRules, passwordType, loading, redirect, otherQuery, copyRightText, canSubmit, route, timer, toggleCaptcha, loginFormRef, usernameRef, passwordRef, showPwd, router, handleLogin, getOtherQuery, ElForm }
}

})